import { formatDate } from "@/lib/api";

function ThreadItem({ thread, isActive, onSelect }) {
  return (
    <button
      data-testid={`thread-${thread.thread_id}`}
      onClick={() => onSelect(thread)}
      className={`w-full text-left p-4 md:p-3 border-b border-black hover:bg-yellow-100 ${isActive ? "bg-yellow-100" : "bg-white"}`}
    >
      <div className="font-mono-data text-xs uppercase font-bold truncate">{thread.other?.name || "Unknown"}</div>
      <div className="text-xs truncate text-gray-700">{thread.listing?.title}</div>
      <div className="text-xs text-gray-500 truncate">{thread.last?.body}</div>
      <div className="font-mono-data text-[10px] uppercase text-gray-500 mt-1">{formatDate(thread.last?.created_at)}</div>
    </button>
  );
}

export function ThreadList({ threads, activeId, onSelect, className }) {
  return (
    <aside className={className} data-testid="threads-list">
      {threads.length === 0 && <div className="p-6 font-mono-data text-xs uppercase text-gray-500">No conversations yet.</div>}
      {threads.map((t) => (
        <ThreadItem key={t.thread_id} thread={t} isActive={activeId === t.thread_id} onSelect={onSelect} />
      ))}
    </aside>
  );
}
